import { http } from '@/api/http';
import { ApiRequestError } from '@/api/client';

const SEND_REGISTER_CODE_PATH = '/system/user/send_register_code';
const REGISTER_PATH = '/system/user/register';

export interface RegisterHttpUserInfo {
  user_id?: string;
  user_name?: string;
  sys_permissions?: string;
  email?: string;
  mobile?: string;
  avatar?: string;
  sex?: number;
}

export interface RegisterHttpResponse {
  error?: boolean;
  message?: string;
  data?: string;
  userInfo?: RegisterHttpUserInfo[];
}

export async function postSendRegisterCode(email: string): Promise<void> {
  await http.post<RegisterHttpResponse>(SEND_REGISTER_CODE_PATH, { email: email.trim() });
}

export async function postRegisterUser(body: {
  sysname: string;
  email: string;
  password: string;
  verification_code: string;
  share_code?: string;
}): Promise<{ token: string; userInfo: RegisterHttpUserInfo | undefined }> {
  const payload: Record<string, string> = {
    sysname: body.sysname.trim(),
    email: body.email.trim(),
    password: body.password,
    verification_code: body.verification_code.trim(),
  };
  if (body.share_code?.trim()) {
    payload.share_code = body.share_code.trim();
  }
  const res = await http.post<RegisterHttpResponse>(REGISTER_PATH, payload, {
    showSuccessModal: true,
  });
  const token = typeof res.data === 'string' ? res.data : '';
  if (!token) {
    throw new ApiRequestError('Registration succeeded but no session was returned. Please sign in.');
  }
  return { token, userInfo: res.userInfo?.[0] };
}
